import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import InvitationPage from './views/2023';
import ParallaxCard from './views/2025';
import GraduationCard from './views/graduation';
import NotFound from './views/404';
import ValentineCard from "./views/valentine";

function RedirectToExternal() {
    useEffect(() => {
        window.location.href = 'https://www.idna-card.de';
    }, []);

    return null;
}

function App() {

    return (
        <Router>
            <Routes>
                <Route path="/"
                       element={<RedirectToExternal />} />
                <Route path="/2023"
                       element={<InvitationPage />} />
                <Route path="/invite/:name?"
                       element={<ParallaxCard
                               date =  "01.02.2025, ab 19:00 Uhr"
                               location = "Röllbacher Weg 9, Röllbach"
                               theme =  "Neon-Night 🌟"
                               message = "Außer guter Laune ist nichts mitzubringen!!! <br/> Ich freue mich auf Dich! 🥳"
                               heading ="Einladung zu meiner <br/> Geburtstagsparty 🎂"
                               description = "Klicke, um die Einladung zu öffnen!"
                               disclaimer = "PS: Zieh Dich warm an, wir feiern in der Garage. Du kannst natürlich auch gerne Deinen Freund/Deine Freundin mitbringen."
                       />}
                />
                <Route path="/konna/:name?"
                       element={<GraduationCard
                            date =  "21.06.2025, from 19:00"
                            location = "Evilion Beach, Nei Pori"
                            theme =  "business casual 👔"
                            message = "Nothing to bring except good mood!!! <br/> I'm looking forward to seeing you! 🥳"
                            heading ="Invitation to my <br/> birthday and graduation party 🎓"
                            description= "click to open the invitation!"
                            disclaimer = "PS: You can of course bring your friend."
                            metatitle  = "Graduation party! 🎓"
                            metadescription = "You are invited to my graduation party! Click to open the invitation!"
                       />}
                />
                <Route
                    path="/valentine/:name?"
                    element={
                        <ValentineCard
                            coverTitle="Willst du mein Valentine 2026 sein?"
                            coverDescription="Klick mich 😏"
                            heading="🌹 Valentinstag Anfrage 🌹"
                            message="Ich habe lange überlegt…<br/>und die Antwort ist klar:<br/><strong>Du + Ich = perfekter Tag ❤️</strong>"
                            yesText="JA 😍"
                            noText="Nein 🙄"
                            disclaimer="(Die richtige Antwort ist übrigens JA)"
                            whatsapp="+491701110607"
                            whatsappMessage="Ja super gerne, ich kann mir niemand besseren vorstellen als mit dir den Tag zu verbringen :)"
                            metatitle="Für dich ❤️"
                            metadescription="Eine besondere Nachricht"
                            themecolor="#ff4d6d"
                        />
                    }
                />

                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default App;